module.exports = __webpack_public_path__ + "static/media/afaa.185983fa.png";